import React, {Component} from 'react';
//import 'intersection-observer'; // optional polyfill
import Observer from '@researchgate/react-intersection-observer';
import borderRepeat from '../../assets/images/border-repeat.png'
import artCitiesLogo from '../../assets/images/artCities.jpg'
import { Row } from 'antd';
import { FormattedMessage } from 'react-intl';

const contexts = {
  1: {mainType: 'support', citySelection: 'all', selectedQuestion: null },
  2: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q17_3' },
  3: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q17_1' },
  4: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q17_4' },
  5: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q17_5' },
  6: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q27_1' },
  7: {mainType: 'support', citySelection: 'all', selectedQuestion: 'QCELTH_a3' },
  7777777: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q28_6' },
  8: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q22_1' },
  9: {mainType: 'support', citySelection: 'Brugge', selectedQuestion: 'Q22_1' },
  10: {mainType: 'support', citySelection: 'Mechelen', selectedQuestion: 'Q22_1' },
  11: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q23_6' },
  12: {mainType: 'support', citySelection: 'all', selectedQuestion: 'Q23_1' },
  13: {mainType: 'drivers', citySelection: 'all', selectedQuestion: 'Q13' },
  14: {mainType: 'drivers', citySelection: 'Mechelen', selectedQuestion: 'Q12_4' },
  15: {mainType: 'drivers', citySelection: 'all', selectedQuestion: 'Q6_1' },
  16: {mainType: 'drivers', citySelection: 'all', selectedQuestion: 'Q6_5' },
  17: {mainType: 'drivers', citySelection: 'all', selectedQuestion: 'Q11_1' },
  18: {mainType: 'future', citySelection: 'all', selectedQuestion: null },
  19: {mainType: 'future', citySelection: 'all', selectedQuestion: 'QCELTH_b9' },
  20: {mainType: 'future', citySelection: 'all', selectedQuestion: 'QCELTH_b10' },
  21: {mainType: 'future', citySelection: 'all', selectedQuestion: 'QCELTH_c1' },
  2111111: {mainType: 'future', citySelection: 'all', selectedQuestion: 'QCELTH_c3' },
  22: {mainType: 'future', citySelection: 'Brugge', selectedQuestion: 'QCELTH_c3' },
  23: {mainType: 'future', citySelection: 'all', selectedQuestion: 'Q15_4' },
}
class Text extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: 0,
      offset: null,
    };
    this.selector = React.createRef();
  }

  componentDidMount = () => {
    const componentYPos = this.selector.current.getBoundingClientRect().y;
    const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const pos = Math.round(componentYPos + (vh - componentYPos) * 0.3)
    const offset = [-pos, -(vh - pos) + 2];
    this.setState({ ...this.state, offset })
  }

  handleIntersection = (event, data) => {
    if(event.isIntersecting){
      this.setState({ data });
      const { setContext } = this.props;
      setContext(contexts[data])
    }
    //console.log(data, event);
  }

  render() {
    const { data, offset } = this.state;
    const rootMargin = offset ? `${offset[0]}px 0px ${offset[1]}px` : '0px'
    return (
      <div ref={this.selector}>
        <strong>
          <p>
            <FormattedMessage id="story.intro" />
          </p>
        </strong>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 1)}>
            <div>
              <h1 style={{ background: `url(${borderRepeat}) repeat-x left bottom`, paddingBottom: 16 }}><FormattedMessage id="story.title.supportImpact" /></h1>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 2)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.support" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 2 ? '6px': 0, paddingLeft: '8px' }}>
              <FormattedMessage id="story.content.support1" />
            </p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 3)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 3 ? '6px': 0, paddingLeft: '8px' }}>
              <FormattedMessage id="story.content.support2" />
            </p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 4)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 4
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.support3" />
            </p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 5)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 5
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.support4" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 6)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.positiveImpact" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 6
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.posImpact1" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 7)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 7
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.posImpact2" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 7777777)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 7777777
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.posImpact3" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 8)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.liveability" /></strong></h5>
            <div style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 8
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.liveability1" /></div>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 9)}>
            <div>
            <div style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 9
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.liveability2" /></div>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 10)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 10
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.liveability3" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 11)}>
            <div>
            <div style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 11
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.liveability4" /></div>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 12)}>
            <div>
            <div style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 12
             ? '6px': 0, paddingLeft: '8px', marginBottom: 8 }}><FormattedMessage id="story.content.liveability5" /></div>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 14)}>
            <div>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.negImpact" /></strong></h5>
            <p><FormattedMessage id="story.content.negImpact1" /></p>
            </div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 14
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.negImpact2" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 15)}>
            <div>
            <h1 style={{ background: `url(${borderRepeat}) repeat-x left bottom`, paddingBottom: 16 }}><FormattedMessage id="story.title.drivers" /></h1>
              <FormattedMessage id="story.content.drivers" />
            <br/>
            <br/>
            <h5><strong><FormattedMessage id="story.subtitle.proud" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 15
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.proud1" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 16)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 16
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.proud2" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 17)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.social" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 17
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.social" />
             </p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 13)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.involved" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 13
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.involved1" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 18)}>
            <div>
            <h1 style={{ background: `url(${borderRepeat}) repeat-x left bottom`, paddingBottom: 16 }}><FormattedMessage id="story.title.future" /></h1>
            <FormattedMessage id="story.content.future" />
            </div>
          </Observer>
          <br/>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 19)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.policy" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 19
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.policy1" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 20)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 20
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.policy2" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 21)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.personal" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 21
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.personal1" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 2111111)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 2111111
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.personal2" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 22)}>
            <div>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 22
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.personal3" /></p>
            </div>
          </Observer>
          <Observer
                rootMargin={rootMargin}
                onChange={(event) => this.handleIntersection(event, 23)}>
            <div>
            <h5><strong><FormattedMessage id="story.subtitle.travelers" /></strong></h5>
            <p style={{ borderLeftStyle: 'solid', borderLeftColor: '#ffe616', borderLeftWidth: data === 23
             ? '6px': 0, paddingLeft: '8px' }}><FormattedMessage id="story.content.travelers1" /></p>
            </div>
          </Observer>
          <div>
            <p><FormattedMessage id="story.content.travelers2" /></p>
          </div>
        <h1><FormattedMessage id="story.title.methodology" /></h1>
        <FormattedMessage id="story.content.methodology" /> <a href="https://www.toerismevlaanderen.be/kunststeden#bewonersonderzoek" target="blank"><FormattedMessage id="story.content.methodologyLink" /></a>
        <br/>
        <Row type="flex" justify="center">
            <img src={artCitiesLogo} style={{ width: '100%', height: "100%", padding: 15 }} alt='logo'/>
        </Row>
        <br/>
      </div>
    );
  }
}

export default Text;
